import { buildService } from './decorated-service';
import settings from '../../../settings.json';

const api = buildService('/nasu-svc/service');

export const mockWebNASUAgreements = [
  {
    agreementID: '1500066907',
    agreementType: 'ROLLOVER_IRA',
    productType: 'MUTUAL_FUND',
    balanceAsOf: 50000.0,
    eligibleForTransaction: true,
    agreementNumber: '****5448',
    trpCode: 'BCG',
    ticker: 'TRBCX',
    fundName: 'T. Rowe Price Blue Chip Growth Fund',
    shortName: 'Blue Chip Growth Fund',
    registrationGroupKey: 'RolloverIRA0',
    owner: true,
    agreementParties: [
      {
        name: {
          firstName: 'UKCWG',
          middleName: '',
          lastName: 'DUKOYU',
          suffix: '',
          fullName: 'UKCWG DUKOYU'
        },
        role: 'OWNR',
        primaryParty: true
      }
    ]
  },
  {
    agreementID: '1500066908',
    agreementType: 'ROLLOVER_IRA',
    productType: 'MUTUAL_FUND',
    balanceAsOf: 10000.0,
    eligibleForTransaction: false,
    agreementNumber: '****0222',
    trpCode: 'MDX',
    ticker: 'MDXBX',
    fundName: 'Maryland Tax-Free Bond Fund',
    shortName: 'Maryland Tax Free Bond',
    registrationGroupKey: 'RolloverIRA0',
    owner: true,
    agreementParties: [
      {
        name: {
          firstName: 'UKCWG',
          middleName: '',
          lastName: 'DUKOYU',
          suffix: '',
          fullName: 'UKCWG DUKOYU'
        },
        role: 'OWNR',
        primaryParty: true
      }
    ]
  },
  {
    agreementID: '1500066910',
    agreementType: 'TRADITIONAL_IRA',
    productType: 'MUTUAL_FUND',
    balanceAsOf: 5000.0,
    eligibleForTransaction: false,
    agreementNumber: '****0256',
    trpCode: 'MDX',
    ticker: 'MDXBX',
    fundName: 'Maryland Tax-Free Bond Fund',
    shortName: 'Maryland Tax Free Bond',
    registrationGroupKey: 'TraditionalIRA0',
    owner: true,
    agreementParties: [
      {
        name: {
          firstName: 'CONTRI',
          middleName: '',
          lastName: 'TRADITIONAL',
          suffix: '',
          fullName: 'CONTRI TRADITIONAL'
        },
        role: 'OWNR',
        primaryParty: true
      }
    ]
  },
  {
    agreementID: '1500066909',
    agreementType: 'INDIVIDUAL_IRA',
    productType: 'MUTUAL_FUND',
    balanceAsOf: 60000.0,
    eligibleForTransaction: true,
    agreementNumber: '****5450',
    trpCode: 'HSX',
    ticker: 'PRHSX',
    fundName: 'T. Rowe Price Health Sciences Fund',
    shortName: 'Health Sciences Fund',
    registrationGroupKey: 'Individual1',
    owner: true,
    agreementParties: [
      {
        name: {
          firstName: 'UKCWG',
          middleName: '',
          lastName: 'DUKOYU',
          suffix: '',
          fullName: 'UKCWG DUKOYU'
        },
        role: 'OWNR',
        primaryParty: true
      }
    ]
  }
];

export const mockWebNASUMinorAgreements = [
  {
    agreementID: '1900001204',
    agreementType: 'UGMA_UTMA',
    productType: 'MUTUAL_FUND',
    balanceAsOf: 0.0,
    agreementNumber: '****1500',
    trpCode: 'BCG',
    ticker: 'TRBCX',
    fundName: 'T. Rowe Price Blue Chip Growth Fund',
    shortName: 'Blue Chip Growth Fund',
    registrationGroupKey: 'UGMA_UTMA0',
    owner: false,
    eligibleForTransaction: true,
    agreementParties: [
      {
        name: {
          firstName: 'MAVR',
          middleName: '',
          lastName: 'VUMCKKLKGSHLDLHRZBVS',
          suffix: '',
          fullName: 'MAVR VUMCKKLKGSHLDLHRZBVS'
        },
        role: 'CUST',
        primaryParty: false
      },
      {
        name: {
          firstName: 'Minor',
          middleName: '',
          lastName: 'Name',
          suffix: '',
          fullName: 'Minor Name'
        },
        role: 'MINR',
        primaryParty: true
      }
    ]
  }
];

export const mockWebNASUJointAgreements = [
  {
    agreementID: '1900001205',
    agreementType: 'JOINT_TENANT',
    productType: 'MUTUAL_FUND',
    balanceAsOf: 0.0,
    agreementNumber: '****1501',
    trpCode: 'BCG',
    ticker: 'TRBCX',
    fundName: 'T. Rowe Price Blue Chip Growth Fund',
    shortName: 'Blue Chip Growth Fund',
    registrationGroupKey: 'JointTenant0',
    owner: true,
    eligibleForTransaction: true,
    agreementParties: [
      {
        name: {
          firstName: 'Test',
          middleName: '',
          lastName: 'Joiunt',
          suffix: '',
          fullName: 'Test Joiunt'
        },
        role: 'OWNR',
        primaryParty: true
      },
      {
        name: {
          firstName: 'First',
          middleName: '',
          lastName: 'Joint',
          suffix: '',
          fullName: 'First Joint'
        },
        role: 'OWNR',
        primaryParty: false
      }
    ]
  }
];

export const mockWebNASUJointAgreements2 = [
  {
    agreementID: '1900001205',
    agreementType: 'JOINT_TENANT',
    productType: 'MUTUAL_FUND',
    balanceAsOf: 0.0,
    agreementNumber: '****1501',
    trpCode: 'BCG',
    ticker: 'TRBCX',
    fundName: 'T. Rowe Price Blue Chip Growth Fund',
    shortName: 'Blue Chip Growth Fund',
    registrationGroupKey: 'JointTenant0',
    owner: true,
    eligibleForTransaction: true,
    agreementParties: [
      {
        name: {
          firstName: 'Test',
          middleName: '',
          lastName: 'Joiunt',
          suffix: '',
          fullName: 'Test Joiunt'
        },
        role: 'OWNR',
        primaryParty: true
      },
      {
        name: {
          firstName: 'First',
          middleName: '',
          lastName: 'Joint',
          suffix: '',
          fullName: 'First Joint'
        },
        role: 'OWNR',
        primaryParty: false
      },
      {
        name: {
          firstName: 'Second',
          middleName: '',
          lastName: 'Joint',
          suffix: '',
          fullName: 'Second Joint'
        },
        role: 'OWNR',
        primaryParty: false
      },
      {
        name: {
          firstName: 'Third',
          middleName: '',
          lastName: 'Joint',
          suffix: '',
          fullName: 'Third Joint'
        },
        role: 'OWNR',
        primaryParty: false
      }
    ]
  }
];

export const mockAgreements = [
  {
    fundName: 'Diversified Mid-Cap Growth',
    ticker: 'PRDMX',
    trpCode: 'DMG',
    agreementType: 'ROLLOVER_IRA',
    eligibleForTransaction: true,
    agreementKey: {
      agreementNumber: 112233441,
      agreementID: 1540000314,
      checkSum: 5,
      uniqueKey: 'aidn-1500072143-112233441'
    },
    balanceAsOf: 100000
  },
  {
    fundName: 'Diversified Mid-Cap Growth',
    ticker: 'PRDMX',
    trpCode: 'DMG',
    agreementType: 'TRADITIONAL_IRA',
    eligibleForTransaction: true,
    agreementKey: {
      agreementNumber: 112233442,
      agreementID: 1540000315,
      checkSum: 5,
      uniqueKey: 'aidn-1500072143-112233441'
    },
    balanceAsOf: 100000
  },
  {
    fundName: 'Blue Chip Growth',
    ticker: 'TRBCX',
    trpCode: 'BCG',
    agreementType: 'ROLLOVER_IRA',
    eligibleForTransaction: true,
    agreementKey: {
      agreementNumber: 114643443,
      agreementID: 1540000316,
      checkSum: 5,
      uniqueKey: 'aidn-1500072143-114643441'
    },
    balanceAsOf: 10000
  },
  {
    fundName: 'Blue Chip Growth',
    ticker: 'TRBCX',
    trpCode: 'BCG',
    agreementType: 'TRADITIONAL_IRA',
    eligibleForTransaction: true,
    agreementKey: {
      agreementNumber: 114643444,
      agreementID: 1540000317,
      checkSum: 5,
      uniqueKey: 'aidn-35000415256-564893541'
    },
    balanceAsOf: 10000
  },
  {
    fundName: 'Blue Chip Growth',
    ticker: 'TRBCX',
    trpCode: 'BCG',
    agreementType: 'ROLLOVER_IRA',
    eligibleForTransaction: true,
    agreementKey: {
      agreementNumber: 114643445,
      agreementID: 1540000318,
      checkSum: 5,
      uniqueKey: 'aidn-35000415256-564893541'
    },
    balanceAsOf: 10000
  },
  {
    fundName: 'Communications & Technology',
    ticker: 'PRMTX',
    trpCode: 'MTF',
    agreementType: 'ROLLOVER_IRA',
    eligibleForTransaction: false,
    agreementKey: {
      agreementNumber: 5722334746,
      agreementID: 1540000319,
      checkSum: 5,
      uniqueKey: 'aidn-1500072143-5722334746'
    },
    balanceAsOf: 1000
  },
  {
    fundName: 'Communications & Technology',
    ticker: 'PRMTX',
    trpCode: 'MTF',
    agreementType: 'ROTH_ROLLOVER_IRA',
    eligibleForTransaction: true,
    agreementKey: {
      agreementNumber: 5722334747,
      agreementID: 1540000320,
      checkSum: 5,
      uniqueKey: 'aidn-1500072143-5722334746'
    },
    balanceAsOf: 1000
  },
  {
    fundName: 'Communications & Technology',
    ticker: 'PRMTX',
    trpCode: 'MTF',
    agreementType: 'ROTH_IRA',
    eligibleForTransaction: true,
    agreementKey: {
      agreementNumber: 5722334748,
      agreementID: 1540000321,
      checkSum: 5,
      uniqueKey: 'aidn-1500072143-5722334746'
    },
    balanceAsOf: 1000
  },
  {
    fundName: 'Communications & Technology',
    ticker: 'PRMTX',
    trpCode: 'MTF',
    agreementType: 'ROTH_IRA',
    eligibleForTransaction: true,
    agreementKey: {
      agreementNumber: 5722334749,
      agreementID: 1540000322,
      checkSum: 5,
      uniqueKey: 'aidn-1500072143-5722334746'
    },
    balanceAsOf: 1000
  }
];

export const mockWebNASUAgreementParties = [
  {
    name: {
      firstName: 'TESTFOURF',
      middleName: '',
      lastName: 'TESTFOURL',
      suffix: '',
      fullName: 'TESTFOURF TESTFOURL'
    },
    role: 'OWNR',
    dateOfBirth: '01/01/1985',
    citizenshipType: 'US_CITIZEN',
    taxID: '916927501',
    primaryParty: true
  }
];

export const getExistingAgreementsService = async (
  agreementTypes: string[] | undefined
): Promise<any> => {
  if (settings['mockedMode']) return mockWebNASUAgreements;
  const existingAgreements = await api.http.post(
    '/agreement/owner',
    {
      agreementTypes,
      productTypes: ['MUTUAL_FUND']
    },
    { ignoreServiceFailure: true }
  );

  /* DE75729 - filter out sweep agreements, as those pertain to Brokerage products */
  if (existingAgreements.length) {
    return existingAgreements.filter((agreement: any) => !agreement.sweep);
  }

  return [];
};

export const getAddtionalCustomersExistingAgreementsService = async (
  additionalCustomerExistingAgreementspayload: any
): Promise<any> => {
  return api.http.post(
    '/agreement/owner',
    additionalCustomerExistingAgreementspayload,
    { ignoreServiceFailure: true }
  );
};

export const getAgreementParties = async (
  agreementID: number
): Promise<any> => {
  if (settings['mockedMode']) return mockWebNASUAgreementParties;
  return api.http.get(`/agreement/${agreementID}/agreement-parties`);
};

export const getOCRExistingAgreementsService = async (
  businessPartyId: number | undefined,
  agreementTypes: string[] | undefined
): Promise<any> => {
  if (settings['mockedMode']) return mockAgreements;
  const errorCodes = [204, 404, 403, 500];

  return api.http.post(
    '/agreement/abbreviated/owner/payload',
    {
      agreementTypes,
      productTypes: ['MUTUAL_FUND'],
      individualInvestorCustomerID: {
        businessPartyId
      }
    },
    {
      errorCodes,
      ignoreServiceFailure: true
    }
  );
};

export default api;
